import { DateTime } from 'luxon';
import { SupportedDateTimeFormat } from './supported-datetime-format.enum';
import { WeekdayService } from '../service/weekday.service';
import { BaseLocaleData } from './base.locale-date';

export class LT_LT_LocaleData extends BaseLocaleData {
  constructor(protected weekdayService: WeekdayService) {
    super(weekdayService);
  }

  format(value: DateTime, format: SupportedDateTimeFormat) {
    switch (format) {
      case SupportedDateTimeFormat.DAY_SHORT:
        return value.toFormat('ccc'); // pr, an, tr...
      case SupportedDateTimeFormat.MONTH_SHORT:
        return value.toFormat('MMM'); // rugs., spal.
      case SupportedDateTimeFormat.MONTH_WIDE:
        return value.toFormat('MMMM'); // rugsėjis, spalis
      case SupportedDateTimeFormat.MONTH_YEAR_WIDE:
        return value.toFormat("yyyy 'm.' MMMM"); // 2025 m. rugsėjis
      case SupportedDateTimeFormat.DATE_SHORT:
        return value.toFormat('yyyy-MM-dd'); // 2025-09-02
      case SupportedDateTimeFormat.DATE_SHORT_WITH_WEEKDAY:
        const cwf1 = this.customWeekdayFormat(value, 'cccc, yyyy-MM-dd'); // antradienis, 2025-09-02
        return value.toFormat(cwf1);
      case SupportedDateTimeFormat.DATE_SHORT_WITH_WEEKDAY_SHORT:
        const cwf2 = this.customWeekdayFormat(value, 'ccc, yyyy-MM-dd', 'ccc'); // an, 2025-09-02
        return value.toFormat(cwf2);
      case SupportedDateTimeFormat.DAY_MONTH_WITH_WEEKDAY_SHORT:
        const cwf3 = this.customWeekdayFormat(value, 'ccc, MM-dd', 'ccc'); // an, 09-02
        return value.toFormat(cwf3);
      case SupportedDateTimeFormat.DATE_SHORT_WITH_WEEKDAY_FULL:
        const cwf4 = this.customWeekdayFormat(value, "cccc, yyyy 'm.' MMMM d 'd.'"); // antradienis, 2025 m. rugsėjo 2 d.
        return value.toFormat(cwf4);
      case SupportedDateTimeFormat.TIME_SIMPLE: // 16:45
        return value.toFormat('HH:mm');
      case SupportedDateTimeFormat.CARD_EXPIRATION: // 09/25
        return value.toFormat('MM/yy');
      default:
        return value.toLocaleString();
    }
  }
}

export const LT_LT_DatePartOrder = 'dmy';
